import { mutatorAction } from 'satcheljs';
import { getGroupFolderHierarchy } from '../selectors/getGroupFolderHierarchy';

export default mutatorAction(
    'deleteGroupFoldersFromStore',
    (groupId: string, folderIdsToDelete: string[]) => {
        const folderHierarchy = getGroupFolderHierarchy(groupId)?.folderHierarchy;
        if (folderHierarchy) {
            folderIdsToDelete.forEach(folderId => {
                folderHierarchy.delete(folderId);
            });
        }
    }
);
